<template>
  <reference-filter :label="label" :count="count">
    <v-text-field
      v-model="minValueModel"
      :placeholder="minPlaceholder"
      :rules="rules"
      hide-details="auto"
      class="mt-0 pt-0 text-body-2"
      @input="$emit('update:minValue', $event)"
    />
    <v-text-field
      v-model="maxValueModel"
      :placeholder="maxPlaceholder"
      :rules="rules"
      hide-details="auto"
      class="mt-0 pt-0 text-body-2"
      @input="$emit('update:maxValue', $event)"
    />
  </reference-filter>
</template>

<script>
import ReferenceFilter from './ReferenceFilter';

export default {
  name: 'ReferenceFilterValueRange',
  components: { ReferenceFilter },
  props: {
    label: {
      type: String,
      required: true,
    },
    minValue: {
      type: Number,
      default: null,
    },
    maxValue: {
      type: Number,
      default: null,
    },
    minPlaceholder: {
      type: String,
      default: 'Min',
    },
    maxPlaceholder: {
      type: String,
      default: 'Max',
    },
  },
  emits: ['update:minValue', 'update:maxValue'],
  data: () => ({
    rules: [(v) => !v || /^\d+$/.test(v) || 'Must be a number'],
  }),
  computed: {
    count() {
      return this.minValue || this.maxValue ? 1 : 0;
    },
    minRuleFailing() {
      return (
        this.minValue &&
        !this.rules.every((rule) => rule(this.minValue))
      );
    },
    maxRuleFailing() {
      return (
        this.maxValue &&
        !this.rules.every((rule) => rule(this.maxValue))
      );
    },
    minValueModel: {
      get() {
        return this.minValue;
      },
      set(value) {
        if (!this.minRuleFailing) {
          this.$emit('update:minValue', value);
        }
      },
    },
    maxValueModel: {
      get() {
        return this.maxValue;
      },
      set(value) {
        if (!this.maxRuleFailing) {
          this.$emit('update:maxValue', value);
        }
      },
    },
  },
};
</script>
